function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useEffect, useState } from 'react';
import { LoadingOverlay } from '@deephaven/components';
import { useClient } from '@deephaven/jsapi-bootstrap';
import { getErrorMessage } from '@deephaven/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var ServerConfigContext = /*#__PURE__*/createContext(null);
ServerConfigContext.displayName = 'ServerConfigContext';
/**
 * ServerConfigBootstrap component. Handles loading the server config.
 */
export function ServerConfigBootstrap(_ref) {
  var children = _ref.children;
  var client = useClient();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    serverConfig = _useState2[0],
    setServerConfig = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(function initServerConfigValues() {
    var isCanceled = false;
    function loadServerConfigValues() {
      return _loadServerConfigValues.apply(this, arguments);
    }
    function _loadServerConfigValues() {
      _loadServerConfigValues = _asyncToGenerator(function* () {
        try {
          var newServerConfigValues = yield client.getServerConfigValues();
          if (!isCanceled) {
            setServerConfig(new Map(newServerConfigValues));
          }
        } catch (e) {
          if (!isCanceled) {
            setError(e);
          }
        }
      });
      return _loadServerConfigValues.apply(this, arguments);
    }
    loadServerConfigValues();
    return () => {
      isCanceled = true;
    };
  }, [client]);
  var isLoading = serverConfig == null;
  if (isLoading || error != null) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "server-config-bootstrap-loading",
      isLoading: isLoading && error == null,
      errorMessage: getErrorMessage(error)
    });
  }
  return /*#__PURE__*/_jsx(ServerConfigContext.Provider, {
    value: serverConfig,
    children: children
  });
}
export default ServerConfigBootstrap;
//# sourceMappingURL=ServerConfigBootstrap.js.map